module.exports = __webpack_public_path__ + "media/images/sale_crm/picklist-3eb353c1bcaaa979f8a06bd95f7272bb.svg";